import React from 'react'

import { useIntl } from 'react-intl'

import {
  Button,
  BUTTON_VARIANT_SECONDARY,
  Flex,
  Text
} from 'mailup-web-components'

import { useSetRecoilState } from 'recoil'
import { modalManageAlertsState } from 'Pages/MessageCheckupSummary/recoil/state/modals'

const Intro = () => {
  const intl = useIntl()
  const setAlertModalState = useSetRecoilState(modalManageAlertsState)
  const handleManageAlerts = () => {
    setAlertModalState(prev => ({
      ...prev,
      show: true,
      canSaveFromPage: false
    }))
  }

  return (
    <Flex width='100%' alignItems='center' justifyContent='space-between'>
      <Text>{intl.formatMessage({ id: 'Load.EmailCheckUp.Intro' })}</Text>

      <Button
        data-mu-test='emailCheckUp-ManageAllert-click'
        kind={BUTTON_VARIANT_SECONDARY}
        onClick={handleManageAlerts}
      >
        {intl.formatMessage({ id: 'Load.EmailCheckUp.MenageAllert' })}
      </Button>
    </Flex>
  )
}

export default Intro
